import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import useToggle from '../hooks/useToggle';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CustomModalHeader from './CustomModalHeader';

import { useTranslation } from 'react-i18next';
import SolidButton from "./SolidButton";

export default function WithConfirmation({title, body, children, skip, confirmMessage, done, onOk}) {

    const {t} = useTranslation()
    const [isOpen, toggle] = useToggle(false);
    const [callback, setCallback] = useState(() => {})
    const [status, setStatus] = useState('new')

    useEffect(() => {
        if(!confirmMessage && status === 'confirmed') {
            toggle();
        }
    }, [status, confirmMessage, toggle])

    useEffect(() => {
        setStatus('new')
    }, [isOpen])

    function show(onConfirm) {
        return function(event) {

            if(skip) {
                onConfirm(event);
                return
            }

            event.preventDefault();
            event.persist();

            toggle();
            setCallback(function() {
                return function() {
                    onConfirm(event)
                }
            });
        }
    }


    function handleConfirm() {
        if(status === 'new') {
            setStatus('confirmed')
            callback();
        } else {
            if(onOk) {
                onOk();
            }
            toggle();
        }
    }

    const confirmButtonStyle = status === 'new' ?
        {} : {margin:'auto'}

    return (
        <React.Fragment>
            {children(show)}
            <Modal isOpen={isOpen} toggle={toggle}>
              <CustomModalHeader toggle={toggle}>{title}</CustomModalHeader>
              <ModalBody>
                {
                    status === 'new' || !done ?
                    body :
                    confirmMessage
                }
              </ModalBody>
              <ModalFooter>
                <SolidButton color="primary" onClick={handleConfirm}
                    style={confirmButtonStyle}
                    disabled={status === 'confirmed' && !done}>{t('accept')}</SolidButton>{' '}
                {
                    status === 'new' || !confirmMessage ? <Button color="secondary" onClick={toggle}>{t('cancel')}</Button> : null
                }
              </ModalFooter>
            </Modal>
        </React.Fragment>
    )

}
